import script from "./DesktopLinkItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesktopLinkItem.vue?vue&type=script&lang=ts&setup=true"

import "./DesktopLinkItem.vue?vue&type=style&index=0&id=d8414fca&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8414fca"]])

export default __exports__